<template>
  <div class="sub-header">
    <div class="header">
      <h1  class="d-flex justify-content-center ">
        <span v-on:click="goBack" class="back-icon cursor-pointer">
          <svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8355 0.482461C12.2638 -0.0892057 11.3422 -0.0892057 10.7705 0.482461L1.0755 10.1775C0.620503 10.6325 0.620503 11.3675 1.0755 11.8225L10.7705 21.5175C11.3422 22.0891 12.2638 22.0891 12.8355 21.5175C13.4072 20.9458 13.4072 20.0241 12.8355 19.4525L4.38884 10.9941L12.8472 2.53579C13.4072 1.97579 13.4072 1.04246 12.8355 0.482461Z" fill="#353535"></path>
          </svg>
         </span>
         <h1 class="xxl">
           {{title}}
        </h1>
      </h1>
      <div
      id="job-counts-wrapper"
      class="info d-sm-flex pl-3 pr-3 justify-content-center align-items-center text-center"
    >
      <div class="collar-text">
        {{ resource['hrvenue.interviewlist.right']  }}&nbsp;
      </div>
      <div class="job-count">
        {{ creditCount }}
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InterviewHeader',

  components: {},
  props: {
    title: { type: String, required: true },
    creditCount: { type: [Number, String], required: true, default: '' },
    isShowCredit: { type: Boolean, required: true },
  },
  data() {
    return {
    };
  },

  created() {
  },

  methods: {
    goBack() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'HrVenueView',
        params: {
          lang,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.back-icon{
  display: flex;
  align-items: center;
  margin-right: 20px;
}
</style>
